import styled from 'styled-components';
import { ScrollUpIcon } from '../icons';
import { addAlpha } from '@algoan/deep-dive/theme';

export interface ArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'up' | 'right' | 'left';
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({ variant, ...buttonAttributes }) => {
  return (
    <S.Container variant={variant} {...buttonAttributes}>
      <ScrollUpIcon />
    </S.Container>
  );
};

const S = {
  Container: styled.button<{
    variant: ArrowButtonProps['variant'];
  }>`
    border: 1px solid ${(props) => props.theme.secondary.softBlue2};
    border-radius: 4px;
    background-color: white;
    width: 40px;
    height: 40px;
    box-shadow: 0px 0px 10px ${(props) => addAlpha(props.theme.algoanBlue, 0.1)};
    &:hover {
      cursor: pointer;
      background-color: ${(props) => props.theme.secondary.softBlue2};
      box-shadow: 0px 0px 15px ${(props) => addAlpha(props.theme.algoanBlue, 0.2)};
    }
    &:hover .arrow {
      fill: white;
    }

    &[disabled] {
      opacity: 0.5;
      pointer-events: none;
    }

    ${({ variant }) => {
      switch (variant) {
        case 'right':
          return `transform: rotate(90deg);`;
        case 'left':
          return `transform: rotate(-90deg);`;
      }
    }}
  `,
};
